import { useState, useEffect } from "react";

export const useLike = (id?: number) => {
  const [like, setLike] = useState(false);

  useEffect(() => {
    if (!id) return;

    const currentWishList = localStorage.getItem("wishList") || "";
    const wishListArray = currentWishList ? currentWishList.split(",") : [];

    // Check if the id is in the wishlist
    const isLiked = wishListArray.includes(id.toString());
    setLike(isLiked);
  }, [id]);

  const handleLike = () => {
    const currentWishList = localStorage.getItem("wishList") || "";
    const wishListArray = currentWishList ? currentWishList.split(",") : [];

    let updatedWishList;

    if (like && id) {
      updatedWishList = wishListArray.filter(
        (item: string) => item !== id.toString(),
      );
    } else {
      updatedWishList = [...wishListArray, id];
    }

    localStorage.setItem("wishList", updatedWishList.join(","));

    setLike(!like);
  };

  return { like, handleLike };
};
